import type React from 'react';
import { Controller, FormProvider } from 'react-hook-form';
import { CaptchaVerificationModal } from '@pages/personal/client/editor-page/Modals/CaptchaVerificationModal/index.tsx';
import { VerificationEmailModal } from '@pages/personal/client/editor-page/Modals/VerifyEmail/index.tsx';
import { VerificationPhoneModal } from '@pages/personal/client/editor-page/Modals/VerifyPhone/index.tsx';
import { ContactsArrayEditor } from '@widgets/shared/Forms/ContactsArrayEditor/index.ts';
// import { IClientForm, useClientForm } from '../../model';
import { Birthday } from '@features/clients/client-form/ui/birthday';
import { Email } from '@features/clients/client-form/ui/email';
import { Gender } from '@features/clients/client-form/ui/gender';
import { Phone } from '@features/clients/client-form/ui/phone/';
import { ArrowShortLeft } from '@shared/assets';
import {
  Card,
  IconButton,
  ListBody,
  PageHead,
  PageTitle,
  TextButton,
  TextInputM,
} from '@shared/ui';
import { ImageInputCropper } from '@shared/ui/inputs/image-input-cropper';
import { Loader } from '@src/library/components/common/index.ts';
import useProfileEdit from '@src/library/hooks/user/useProfileEdit';
import * as st from './styles.module.scss';

type Props = {
  // onSubmit: () => void;
  // onCancel: () => void;
  // selected?: number;
};

export const EditorClient: React.FC<Props> = () => {
  const {
    onSubmit,
    emailVerified,
    defaultValues,
    setEmailVerified,
    onSubmitHandler,
    doSaveFormData,
    onPageLeave,
    phoneNumberVerified,
    setPhoneNumberVerified,
    isAuth,
    isLoading,
    ...methods
  } = useProfileEdit();
  return (
    <>
      <PageTitle title={`${isAuth ? 'Редактирование' : 'Создание'} профиля`} />
      <PageHead
        Left={
          <IconButton
            variant="dark"
            onClick={() => {
              // navigate(-1);
              onPageLeave();
              // localStorage.removeItem('clientEditorFormState');
            }}
          >
            <ArrowShortLeft />
          </IconButton>
        }
        Right={
          <TextButton type="submit" disabled={isLoading} onClick={onSubmitHandler}>
            Готово
          </TextButton>
        }
      />
      <ListBody>
        <FormProvider {...methods}>
          {isLoading ? (
            <Loader />
          ) : (
            <form className={st.form} onSubmit={methods.handleSubmit(onSubmit)}>
              <section className={st.body}>
                <Card className={st.block_fio_foto}>
                  <div className={st.photo}>
                    <Controller
                      name="photo"
                      control={methods.control}
                      render={({ field: { value } }) => (
                        <ImageInputCropper
                          aspect={[1, 1]}
                          iconVariant="client"
                          value={value as string}
                          onChange={(value) => {
                            methods.setValue(`photo`, value as string, { shouldDirty: true });
                          }}
                          isValid={!!methods.formState.errors['photo']}
                        />
                      )}
                    />
                  </div>
                  <div className={st.fio}>
                    <TextInputM
                      fullWidth
                      register={methods.register('last_name')}
                      error={methods.formState?.errors?.last_name?.message}
                      placeholder={'Фамилия'}
                    />
                    <TextInputM
                      fullWidth
                      register={methods.register('first_name')}
                      error={methods.formState?.errors?.first_name?.message}
                      placeholder={'Имя'}
                    />
                    <TextInputM
                      fullWidth
                      register={methods.register('middle_name')}
                      error={methods.formState?.errors?.middle_name?.message}
                      placeholder={'Отчество'}
                    />
                  </div>
                </Card>

                <Phone
                  isPresentation={!isAuth}
                  label={'телефон/логин'}
                  isEditable={emailVerified}
                  setPhoneVerified={setPhoneNumberVerified}
                />

                <Email
                  isEditable={phoneNumberVerified}
                  setEmailVerified={(isEmailVerified) => setEmailVerified(isEmailVerified)}
                />

                <Gender />

                <Birthday />

                <ContactsArrayEditor
                  name={'active_contacts'}
                  setValue={methods.setValue}
                  control={methods.control}
                />

                {/*<FormContactsEditor*/}
                {/*  initData={defaultValues?.contacts}*/}
                {/*  onChange={(v) => methods.setValue('contacts', v)}*/}
                {/*  label={'Дополнительные контакты'}*/}
                {/*  onRedirect={doSaveFormData}*/}
                {/*/>*/}
              </section>
            </form>
          )}
        </FormProvider>
        <CaptchaVerificationModal />
        <VerificationEmailModal />
        <VerificationPhoneModal />
      </ListBody>
    </>
  );
};
